import React, { useEffect } from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';
import Close from '../assets/images/close.inline.svg';

const Container = styled.div`
  background-color: rgb(255, 255, 255);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CloseIcon = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  padding: 2vw;
  line-height: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  &:focus {
    outline: 0;
  }
`;

const Modal = ({ selectedImage, onModalClose }) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.keyCode === 27) {
        onModalClose();
      }
    };

    window.addEventListener('keydown', handleEsc);
  }, [onModalClose]);

  return (
    <>
      <Container onClick={onModalClose}>
        <CloseIcon onClick={onModalClose}>
          <Close />
        </CloseIcon>
        <Img
          imgStyle={{
            width: 'auto',
            left: '50%',
            transform: 'translate(-50%, 0)',
          }}
          style={{
            height: '80%',
            width: '100%',
            maxHeight: '50vw',
          }}
          fluid={selectedImage.image.asset.fluid}
          alt={selectedImage.alternativeText}
        />
      </Container>
    </>
  );
};

export default Modal;
